export class CarTypeMasterModel {

    // 車種リスト
    carTypes: Array<any> = []

    // 車種詳細リスト
    carTypeDetails: Array<any> = []

    // 頭文字のリスト
    carTypeInitials: Array<any> = [];

    // メーカーに紐づく頭文字一覧
    carTypeInitialsLinkedMaker: Array<any> = [];

    // 頭文字に紐づく車種一覧
    carTypesLinkedInitial: Array<any> = [];

    // 年式のリスト
    modelYears: Array<any> = [];

    // グレード・型式のリスト
    gradeModels: Array<any> = [];

    // ボディタイプのリスト
    bodyTypes: Array<any> = [];

    /** 選択情報をリセットします */
    public reset() {
        // 車種リスト
        this.carTypes = [];
        // 車種詳細リスト
        this.carTypeDetails = [];
        // メーカーに紐づく頭文字一覧
        this.carTypeInitialsLinkedMaker = [];
        // 頭文字に紐づく車種一覧
        this.carTypesLinkedInitial = [];
        // 年式のリスト
        this.modelYears = [];
        // グレード・型式のリスト
        this.gradeModels = [];
        // ボディタイプ
        this.bodyTypes = [];
    }
}